'use client';
export { default } from './no-results.component';
